import { SubmitHandler, useForm } from 'react-hook-form';
import {
  Text,
  Button,
  Flex,
  useDisclosure,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalFooter,
} from '@chakra-ui/react';
import { InputComponent } from '../form/input';

import { WrapperForm, Checkbox } from './styles';
import { colors } from 'theme/colors';
import { useContext, useState, KeyboardEvent } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { captchaRequest } from 'services/recaptcha';
import { SimulatorContext } from '../../provider/SimulatorProvider';
import { createFirsStepSimulation, createRegisterLP } from 'services/createRegisterLandingPage';
import { postLogin } from 'services/auth';
import { TermsOfUse as TermsOfUseComponent } from '../Terms/TermsOfUse';
import { PrivaceNotive } from '../Terms/PrivaceNotive';
import { openNotification } from 'utils/notification';

export interface IFormSimulator {
  name: string;
  email: string;
  company: string;
  infoEmail: boolean;
}

interface IProps {
  setComponent: React.Dispatch<React.SetStateAction<string>>;
}

export const FormRegisterSimulator: React.FC<IProps> = ({ setComponent }) => {
  const { setFields, fields } = useContext(SimulatorContext);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [TermsOfUse, setTermsOfUse] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isLoading, setIsLoading] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { handleSubmit, register } = useForm<IFormSimulator>({});

  const submit: SubmitHandler<IFormSimulator> = async (data): Promise<void> => {
    try {
      if (!executeRecaptcha) {
        return;
      }
      const newDate = {
        ...data,
        name: data.name.trim(),
        email: data.email.trim(),
        company: data.company.trim(),
      };
      if (newDate.name === '' && newDate.email === '' && newDate.company === '') {
        setFields({ name: true, email: true, company: true });
        setIsLoading(false);
      }
      if (newDate.name === '') {
        setFields(oldState => ({ ...oldState, name: true }));
        setIsLoading(false);
        return;
      } else {
        setFields(oldState => ({ ...oldState, name: false }));
      }
      if (newDate.email === '' || !newDate.email.includes('@')) {
        setFields(oldState => ({ ...oldState, email: true }));
        setIsLoading(false);
        return;
      } else {
        setFields(oldState => ({ ...oldState, email: false }));
      }
      if (newDate.company === '') {
        setFields(oldState => ({ ...oldState, company: true }));
        setIsLoading(false);
        return;
      } else {
        setFields(oldState => ({ ...oldState, company: false }));
      }
      setIsLoading(true);

      const token = await executeRecaptcha('register');
      const resCaptcha = await captchaRequest(token);

      // eslint-disable-next-line no-extra-boolean-cast
      if (!resCaptcha.data) {
        setIsLoading(false);
        return;
      }

      const { data: userLP } = await createRegisterLP(newDate);

      const auth = await postLogin({ userName: newDate.email, password: 'Samdm123*4' });

      localStorage.setItem('LP-token', auth.data.access_token);

      const createUser = await createFirsStepSimulation(auth.data.access_token, userLP);

      localStorage.setItem('id-simulation', String(createUser.data.id));

      setIsLoading(false);
      setComponent('simulate');
    } catch (err: any) {
      openNotification('Acesso negado!', 'error');

      console.log(err);
      setIsLoading(false);
    }
  };

  const handleChangeValidate = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.currentTarget.value;
    const name = ev.target.name;
    const caracteresEspeciaisRegex = /[!@#$%^&*(),.?":{}|<>`´]/;

    if (name === 'name') {
      if (value === '') {
        setFields(oldState => ({ ...oldState, name: true }));
      } else if (caracteresEspeciaisRegex.test(value)) {
        setFields(oldState => ({ ...oldState, name: true }));
      } else {
        setFields(oldState => ({ ...oldState, name: false }));
      }
    }

    if (name === 'email') {
      if (value === '') {
        setFields(oldState => ({ ...oldState, email: true }));
        return;
      } else if (!value.includes('@')) {
        setFields(oldState => ({ ...oldState, email: true }));
        return;
      } else {
        setFields(oldState => ({ ...oldState, email: false }));
      }
    }

    if (name === 'company') {
      if (value === '') {
        setFields(oldState => ({ ...oldState, company: true }));
      } else {
        setFields(oldState => ({ ...oldState, company: false }));
      }
    }
  };

  const onlyLettersAndSpace = (event: KeyboardEvent<HTMLInputElement>): void => {
    const teclaDigitada = event.key;

    // Verifica se a tecla digitada é uma letra, espaço ou caractere especial para acentuar letras
    const regex = /[a-zA-Z\sÀ-ÖØ-öø-ÿ]/;
    const eUmaLetraOuEspacoAcentuado = regex.test(teclaDigitada);

    // Permite apenas letras, espaços e caracteres especiais para acentuar letras
    if (!eUmaLetraOuEspacoAcentuado) {
      event.preventDefault();
    }
  };

  const handleClickModal = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const text = event.currentTarget.textContent?.trim();

    if (text === 'Termos de Uso') {
      setTermsOfUse(true);
      onOpen();
    } else {
      setTermsOfUse(false);
      onOpen();
    }
  };

  return (
    <WrapperForm onSubmit={handleSubmit(submit)}>
      <h1>
        Preencha o <br /> formulário para <br /> simular sua multa.
      </h1>
      <InputComponent
        label={'Nome'}
        {...register('name')}
        id="name"
        error={fields.name}
        messageError="O nome é obrigatório!"
        onChange={handleChangeValidate}
        onKeyDown={onlyLettersAndSpace}
      />
      <InputComponent
        label={'E-mail'}
        type="email"
        {...register('email')}
        error={fields.email}
        messageError="O email é obrigatório!"
        onChange={handleChangeValidate}
      />
      <InputComponent
        label={'Empresa'}
        {...register('company')}
        error={fields.company}
        messageError="Preencha o campo empresa!"
        onChange={handleChangeValidate}
      />

      <Checkbox defaultChecked={true} {...register('infoEmail')}>
        <Text fontSize="0.875rem" fontWeight="700" color="black">
          Quero receber as informações por e-mail
        </Text>
      </Checkbox>

      <Flex justify="space-between">
        <Flex alignItems="flex-start" className="terms">
          <Checkbox
            defaultChecked={acceptTerms}
            onChange={() => setAcceptTerms(oldState => !oldState)}
          >
            Confirmar
            <span>
              {' '}
              <a onClick={handleClickModal}>Termos de Uso</a> e{' '}
              <a onClick={handleClickModal}> Aviso de Privacidade</a>
            </span>
          </Checkbox>
        </Flex>

        <Modal isOpen={isOpen} onClose={onClose} size="5xl">
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>{TermsOfUse ? <TermsOfUseComponent /> : <PrivaceNotive />}</ModalBody>
            <ModalFooter>
              <Button
                _hover={{
                  background: colors.brand.tertiary,
                  filter: 'brightness(1.3)',
                  transition: '0.2s ease',
                }}
                bg={colors.brand.tertiary}
                color="white"
                mr={3}
                onClick={onClose}
              >
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Flex>

      <Button
        type="submit"
        w="7.125rem"
        height="1.9rem"
        bg={colors.brand.tertiary}
        color="white"
        fontWeight="400"
        fontSize="0.75rem"
        borderRadius="4px"
        isLoading={isLoading}
        disabled={!acceptTerms}
        _hover={{
          background: colors.brand.tertiary,
          filter: 'brightness(0.9)',
          transition: '0.2s ease',
        }}
      >
        Simular agora!
      </Button>
    </WrapperForm>
  );
};
